import { render, staticRenderFns } from "./FirmBankAccount.vue?vue&type=template&id=6f72f1a4"
import script from "./FirmBankAccount.vue?vue&type=script&lang=js"
export * from "./FirmBankAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports